/**
 * Handle homepage javascript behavior
 */

window.app = window.app || {};

(function (homeManager, $) {

    /**
     * variable example
     * @type {string}
     */
    var _example = 'example';

    /**
     * Initializes the behavior.
     */
    homeManager.init = function () {
        _handleEvents();
    };

    /**
     * Handle events
     */
    var _handleEvents = function () {

    };

    /**
     * Example function declaration
     */
    var _exampleFunction = function() {

    };
})(
    window.app.homeManager = window.app.homeManager || {},
    jQuery
);
